import { Popup } from 'semantic-ui-react';
import { MasterDescriptorWithHorizontalLevelType } from '../../../../types';

type MasterDescriptorPropsType = {
    masterDescriptor: MasterDescriptorWithHorizontalLevelType;
};

function MasterDescriptor({ masterDescriptor }: MasterDescriptorPropsType) {
    return <Popup pinned on={'click'} content={masterDescriptor.id} trigger={<div>{masterDescriptor.label}</div>} />;
}

export default MasterDescriptor;
